import { render, staticRenderFns } from "./updateScore.vue?vue&type=template&id=6e6c7d4b&"
import script from "./updateScore.vue?vue&type=script&lang=js&"
export * from "./updateScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6c7d4b')) {
      api.createRecord('6e6c7d4b', component.options)
    } else {
      api.reload('6e6c7d4b', component.options)
    }
    module.hot.accept("./updateScore.vue?vue&type=template&id=6e6c7d4b&", function () {
      api.rerender('6e6c7d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eventmanagement/coachmanage/component/updateScore.vue"
export default component.exports